/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import common from '@/api/common'
import get from 'lodash/get'

const INITIAL_STATE = { token: null }

export default {
  namespace: 'common',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setToken(state, { payload }) {
      return { ...state, token: get(payload, 'token') }
    },
  },

  effects: {
    *generatePreviewHtml({ payload, successCallback, errorCallback }, { select, call, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(common.generatePreviewHtml, {
        data: payload,
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },
  },
}
